import { Main } from './components';

const Refunds = () => <Main />;

export default Refunds;
